interface IResponseData<TData> {
  status?: HttpStatus;
  message?: string;
  data?: TData;
  id?: number;
}

export class SearchModel {
  constructor(pageNumber?: number,
              pageSize?: number,
              keyword?: string,
              trangThai?: number,
              idNhanViens?: number[]) {
    this.pageNumber = pageNumber || 1;
    this.pageSize = pageSize || 10;
    this.trangThai = trangThai || 1;
    this.keyword = keyword;
    this.idNhanViens = idNhanViens;

  }
  public pageNumber: number;
  public pageSize: number;
  public keyword: string;
  public id: number;
  public trangThai: number;
  public donViId: number;
  public phongBanId: number;
  public gender: number;
  public searchDate: Date;
  public idNhanViens: number[];
}

export class ResponseData<TData> implements IResponseData<TData> {
  constructor() { }

  status?: HttpStatus;
  messages?: string;
  data?: TData;
  id?: number;
}

interface IPagedList<TData> {
  pageNumber: number;
  pageSize: number;
  pageCount: number;
  totalItemCount: number;
  items: TData[];
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  isFirstPage: boolean;
  isLastPage: boolean;
  firstItemOnPage: number;
  lastItemOnPage: number;
  pageCaption: string;
}

export class PagedList<TData> implements IPagedList<TData> {
  constructor() {
      this.pageNumber = 1;
      this.pageSize = 20;
      this.pageCount = 0;
      this.totalItemCount = 0;
      this.firstItemOnPage = 0;
      this.lastItemOnPage = 0;
  }

  pageNumber: number;
  pageSize: number;
  pageCount: number;
  totalItemCount: number;
  items: TData[];
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  isFirstPage: boolean;
  isLastPage: boolean;
  firstItemOnPage: number;
  lastItemOnPage: number;

  get pageCaption() {
      return `Showing ${this.firstItemOnPage} to ${this.lastItemOnPage} of ${this.totalItemCount} entries (Page ${this.pageNumber} of ${this.pageCount})`;
  }
}

export enum ResponseStatus {
  Error,
  Success,
  InValid,
  SystemLocked,
  AccessDenied
}

export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403
}

export enum RolesType {
  ADMIN = 'ADMIN',
  HR = 'HR',
  MANAGER = 'MANAGER',
  STAFF = 'STAFF'
}


